<template>
  <div>
    <v-card class="sf-card"
            flat>
      <div class="sf-card__header">
        <h2 class="sf-card__title">{{ $t('additionalGuests') }}</h2>
      </div>
      <v-card-text class="sf-card__body">
        <v-checkbox color="primary"
                    class="mt-0 mb-2"
                    hide-details="auto"
                    v-bind:label="$t('iWouldLikeToBringAdditionalGuestsToTheEvent')"
                    v-model="form.hasAdditionalGuests" />
        <v-form ref="form">
          <template v-if="form.hasAdditionalGuests">
            <div class="sf-guest"
                 v-bind:key="index"
                 v-for="(additionalGuest, index) in form.additionalGuests">
              <div class="sf-guest__head">
                <h3 class="sf-section-title mb-0">{{ $t('guest') }} {{ index + 1 }}</h3>
                <v-btn icon
                       small
                       v-bind:title="$t('removeGuest')"
                       v-on:click="removeAdditionalGuest(index)">
                  <v-icon small>ti-x</v-icon>
                </v-btn>
              </div>
              <v-row class="sf-form-row">
                <v-col cols="12" sm="6">
                  <v-text-field dense hide-details="auto"
                                outlined
                                v-bind:label="$t('givenName')"
                                v-bind:rules="[ rules.required, rules.capitalFirstLetter ]"
                                v-model="additionalGuest.givenName" />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field dense hide-details="auto"
                                outlined
                                v-bind:label="$t('familyName')"
                                v-bind:rules="[ rules.required, rules.capitalFirstLetter ]"
                                v-model="additionalGuest.familyName" />
                </v-col>
                <v-col cols="12">
                  <v-text-field dense hide-details="auto"
                                outlined
                                v-bind:label="$t('email')"
                                v-bind:rules="[ rules.required, rules.validEmailAddress ]"
                                v-model="additionalGuest.email" />
                </v-col>
              </v-row>
            </div>
            <v-btn class="mt-2"
                   color="primary"
                   outlined
                   v-if="form.additionalGuests.length <= 9"
                   v-on:click="addAdditionalGuest">
              <v-icon left>ti-plus</v-icon>
              {{ $t('addAnotherGuest') }}
            </v-btn>
          </template>
        </v-form>
      </v-card-text>
      <v-card-actions v-if="nextStepButton != null || previousStepButton != null">
        <v-btn color="primary"
               outlined
               v-if="previousStepButton != null"
               v-on:click="previousStep">
          <v-icon left>ti-arrow-left</v-icon>
          {{ previousStepButton }}
        </v-btn>
        <v-spacer />
        <v-btn color="accent"
               depressed
               v-if="nextStepButton != null"
               v-on:click="nextStep">
          {{ nextStepButton }}
          <v-icon right>ti-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  export default {
    components: {

    },
    computed: {
      rules() {
        return {
          required: v => !!v || this.$t('form.required'),
          capitalFirstLetter: v => !v || /^[A-ZÄÖÜ]/.test(v) || this.$t('form.mustStartWithCapitalLetter'),
          validEmailAddress: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('form.pleaseEnterAValidEmailAddress')
        }
      }
    },
    methods: {
      addAdditionalGuest() {
        this.form.additionalGuests.push({})
      },
      removeAdditionalGuest(index) {
        this.form.additionalGuests.splice(index, 1)
      },
      nextStep() {
        this.$emit('next-step')
      },
      previousStep() {
        this.$emit('previous-step')
      },
      validate() {
        return this.$refs.form.validate()
      }
    },
    name: 'AdditionalGuestsCard',
    props: {
      form: Object,
      nextStepButton: String,
      previousStepButton: String
    }
  }
</script>

<style scoped>
  .sf-guest {
    border: 1px solid var(--sf-border);
    border-radius: 12px;
    margin-top: 16px;
    padding: 16px;
  }

  .sf-guest__head {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
  }
</style>

<i18n>
  {
    "de": {
      "addAnotherGuest": "Einen weiteren Gast hinzufügen",
      "additionalGuests": "Weitere Gäste",
      "email": "E-Mail-Adresse",
      "familyName": "Nachname",
      "givenName": "Vorname",
      "iWouldLikeToBringAdditionalGuestsToTheEvent": "Ich möchte weitere Gäste zur Veranstaltung mitbringen",
      "guest": "Gast",
      "removeGuest": "Gast entfernen"
    },
    "en": {
      "addAnotherGuest": "Add another guest",
      "additionalGuests": "Additional guests",
      "email": "Email",
      "familyName": "Family name",
      "givenName": "Given name",
      "iWouldLikeToBringAdditionalGuestsToTheEvent": "I would like to bring additional guests to the event",
      "guest": "Guest",
      "removeGuest": "Remove guest"
    }
  }
</i18n>